import 'core-js/modules/es.object.assign.js';
import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import { Range } from 'rc-slider';

var RangeSlider = function RangeSlider(_a) {
  var _marks;
  var className = _a.className,
    style = _a.style,
    value = _a.value,
    setValue = _a.setValue,
    min = _a.min,
    max = _a.max,
    rest = __rest(_a, ["className", "style", "value", "setValue", "min", "max"]);
  var marks = (_marks = {}, _marks[min] = {
    label: "" + min
  }, _marks[max] = {
    label: "" + max
  }, _marks);
  return jsx(Range, Object.assign({
    className: classNames('cogs-v10', 'cogs-slider', className),
    style: style,
    min: min,
    max: max,
    value: value,
    onChange: function onChange(nextValue) {
      return setValue(nextValue);
    },
    marks: marks
  }, rest));
};

export { RangeSlider };
